<template>
    <v-card tile elevation="0" style="padding-bottom: 1px" :style="event.mId === $const.DBALL_MARKET_LIVE ? 'background-color: #fff9f3' : ''">
        <v-card-title class="font13 pa-0 market-header" :class="event.mId === $const.DBALL_MARKET_LIVE ? 'live' : 'pregame'">
            <v-tooltip
                :color="$vuetify.theme.dark ? '#5F6673' : '#9e9e9e'"
                :disabled="utils.isMobile()"
                v-if="pricesBest[0] && pricesBest[0][0]"
                open-delay="500"
                top
                :open-on-focus="false"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-avatar
                        v-bind="attrs"
                        v-on="on"
                        size="22"
                        class="ml-2"
                        :color="$vuetify.theme.dark ? '#2b2c30' : event.mId === $const.DBALL_MARKET_LIVE ? '#bd6100' : '#c5c5c5'"
                    >
                        <span class="whiteText font12 bold">
                            {{ pricesBest[0][0].feeds_count }}
                        </span>
                    </v-avatar>
                </template>
                {{ pricesBest[0][0].feeds_count }}
                {{ $tc('event.bookmakers', pricesBest[0][0].feeds_count) }}
            </v-tooltip>
            <span class="pl-2 font-weight-regular">
                {{ $t('event.correctScore') }}
            </span>
            <span v-if="periodId === $const.GAME_PERIOD_1H" class="pl-1 font-weight-regular">
                {{ $t('event.market1H') }}
            </span>
            <v-spacer></v-spacer>
            <v-btn tag="a" v-if="isShowAllMarketsToggle" width="105" small outlined color="tbGreen" class="mr-2 toggle-button font12" @click="toggleAllMarkets">
                <span v-if="isAllExpanded">{{ $t('event.hideAll') }}</span>
                <span v-else>{{ $t('event.showAll') }}</span>
            </v-btn>
            <v-icon v-if="isExpanded" class="mr-2" @click="isExpandedToggle()">mdi-chevron-up</v-icon>
            <v-icon v-else class="mr-2" @click="isExpandedToggle()">mdi-chevron-down</v-icon>
        </v-card-title>
        <v-card-text v-if="isExpanded" class="pt-2">
            <v-row v-for="(prices, i) in pricesBest" :key="i" class="py-1 my-0" :class="$vuetify.breakpoint.width <= 430 ? 'px-0' : ''">
                <v-col class="text-center py-1 d-flex flex-column align-center justify-center" :class="$vuetify.breakpoint.width <= 430 ? 'px-0' : ''">
                    <!--                    <span class="font13 bold grey&#45;&#45;text"-->
                    <!--                        >{{ price.feeds_count }} {{ $tc('event.feeds', price.feeds_count) }}</span-->
                    <!--                    >-->
                </v-col>
                <v-col v-for="(price, j) in prices" :key="j" cols="3" class="text-center py-1" :class="$vuetify.breakpoint.width <= 430 ? 'px-1' : ''">
                    <div
                        v-if="price.price_max"
                        class="odds-buttons cursorPointer"
                        :class="event.mId === $const.DBALL_MARKET_LIVE ? 'live' : 'pregame'"
                        @click.stop="onPriceClick(price, periodId, null, 'price_max', $const.BET_TYPE_CS, $const.BET_SELECTION_CS, 'price_list', 'cthName')"
                    >
                        <div class="font13" style="height: 18px" :class="$vuetify.theme.dark ? '' : 'blackText'">
                            {{ price.score }}
                        </div>
                        <div
                            data-tooltip-position="left"
                            @mouseleave="utils.hideTooltip('tooltip-event')"
                            @mouseenter="
                                JSON.parse(price.price_list)
                                    ? utils.showTooltip($event, utils.listSiteQtip(JSON.parse(price.price_list), true, 0, 2), false, 'tooltip-event')
                                    : null
                            "
                            style="height: 36px"
                        >
                            <div v-if="price.price_max" style="height: 18px">
                                <span :class="getHighlightClass(price, 0, 'price_max', price.score)" class="odds nowrap font13">
                                    {{ utils.roundPrice(price.price_max) }}
                                </span>
                            </div>

                            <div :class="['bookmaker' + price.price_max_site_id, 'font12']" style="height: 18px">
                                {{ $const.SITE_NAME[price.price_max_site_id] }}
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col class="text-center py-1 d-flex flex-column align-center justify-center" :class="$vuetify.breakpoint.width <= 430 ? 'px-0' : ''">
                    <!--                    <span-->
                    <!--                        class="font13"-->
                    <!--                        :class="[price.margin_perc > 100 ? 'greyText' : 'bold greenText']"-->
                    <!--                        v-if="price.margin_perc"-->
                    <!--                        >{{ price.margin_perc.toFixed(2) }}%</span-->
                    <!--                    >-->
                </v-col>
            </v-row>
            <v-row v-if="loadMore !== true && prices.length > 9">
                <v-btn
                    tag="a"
                    outlined
                    small
                    color="tbGreen"
                    class="mx-auto showMore font12"
                    style="border: 1px solid #e6e6e6; color: white"
                    @click="loadMorePrices()"
                >
                    {{ $t('feed.showMore') }}
                </v-btn>
            </v-row>
            <v-row v-else-if="prices.length > 9">
                <v-btn
                    tag="a"
                    outlined
                    small
                    color="tbGreen"
                    class="mx-auto showMore font12"
                    style="border: 1px solid #e6e6e6; color: white"
                    @click="loadMore = false"
                >
                    {{ $t('feed.showLess') }}
                </v-btn>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<style scoped>
    @import url('./styleMarketsCore.css');
</style>

<script>
    import { eventMethods, eventGetters } from './eventCore';
    import Constants from 'Helpers/constants';

    export default {
        name: 'app-eventMarketCS',
        props: {
            periodId: {
                default: Constants.GAME_PERIOD_FT,
                type: Number,
            },
            isShowAllMarketsToggle: {
                default: false,
                type: Boolean,
            },
            isAllExpanded: {
                default: false,
                type: Boolean,
            },
            isShow: {
                default: false,
                type: Boolean,
            },
        },
        watch: {},
        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },
        data() {
            return {
                odds: {},
                isExpanded: true,
                loadMore: false,
            };
        },

        methods: {
            ...eventMethods(),

            toggleAllMarkets() {
                this.$emit('toggleAllMarkets');
            },
        },
        computed: {
            ...eventGetters(),
            pricesBest() {
                let arr = [];

                const chunkSize = 3; //3 prices in one row
                for (let i = 0; i < this.prices.length; i += chunkSize) {
                    const chunk = this.prices.slice(i, i + chunkSize);
                    arr.push(chunk);
                }
                return this.loadMore ? arr : arr.slice(0, 3); //3 first lines
            },
            prices() {
                return this.periodId === this.$const.GAME_PERIOD_1H ? this.$store.getters['EventModule/getCs1h'] : this.$store.getters['EventModule/getCs'];
            },

            event() {
                return this.$store.getters['EventModule/getEvent'];
            },

            eventStats() {
                return this.$store.getters['EventModule/getStats'];
            },
            betFeedData: {
                get() {
                    return this.$store.getters['EventModule/getBetFeedData'];
                },
                set(value) {
                    this.$store.commit('EventModule/setBetFeedData', value);
                },
            },
        },
    };
</script>
